import React, { FC, useMemo } from 'react';
import { Tag } from 'antd';
import { TagProps } from 'antd/lib/tag';
import { PatientStatus, patientStatusLabelMap } from 'models/patient';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const patientStatusColorMap = new Map<
  PatientStatus,
  TagProps['color'] | undefined
>([
  [PatientStatus.Active, 'green'],
  [PatientStatus.Archived, undefined],
]);

export interface PatientStatusTagProps {
  status: PatientStatus;
}

export const PatientStatusTag: FC<PatientStatusTagProps> = ({ status }) => {
  const intlMessage = useFormatMessage();

  const label = useMemo(
    () => intlMessage({ id: patientStatusLabelMap.get(status) ?? status }),

    [status, intlMessage]
  );
  const color = useMemo(() => patientStatusColorMap.get(status), [status]);

  return (
    <Tag color={color} key={status}>
      {label && label.toUpperCase()}
    </Tag>
  );
};
